import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Postdata } from "../../helpers/api.service";
import HttpService from "../../helpers/httpServices";
import { message } from "../../redux/actions/toastActions";
import { Topbar } from "../../components/include/Topbar";
import { isPermission, isRole, isRoleType } from "../../redux/selectors/authSelector";
import Error403Page from "../ErrorPage";
import { toast } from "sonner";
import axios from "axios";
import { useCountryNavigate } from "../../components/common/UseCountryNavigate";

const Add_stream = () => {
  const [errors, setErrors] = useState({});
  const [loader, setLoader] = useState(false);
  const location = useLocation();
  // const navigate = useNavigate();
  const navigate = useCountryNavigate();
  // const dispatch = useDispatch();
  const params = useParams();
  // const fileInputRef = useRef();
  // const [selectedFile, setSelectedFile] = useState(null);
  const permissions = useSelector(isPermission);
  const role = useSelector(isRole);
  const role_type = useSelector(isRoleType);

  console.log("permissions", permissions);
  const isAccessible =
    role === "admin" ||
    role === "subadmin" ||
    role == "schooladmin" ||
    (permissions && (permissions?.includes("edit_Education") || permissions?.includes("edit_School"))) ||
    false;

  const [teacherList, setTeacherList] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [loading, setLoading] = useState(false);

  const teacherBoxRef = useRef(null);
  const [isTeacherValid, setIsTeacherValid] = useState(false); // valid until user changes it
  const schoolId = localStorage.getItem("activeSchoolId");
  const [selectedTeacherId, setSelectedTeacherId] = useState(null);
  const mode = localStorage.getItem("mode");
  const { id } = useParams();
  useEffect(() => {
    function handleClickOutside(e) {
      if (teacherBoxRef.current && !teacherBoxRef.current.contains(e.target)) {
        setShowDropdown(false); // close only; DO NOT clear value
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const [formData, setFormData] = useState({
    grade: "",
    name: "",
    teacher: "",
    no_of_students: 1,
    teacher_image: "",
    description: "",
  });

  const validate = () => {
    const newErrors = {};
    if (!formData.grade) newErrors.grade = true;
    if (!formData.name) newErrors.name = true;
    if (!formData.no_of_students) newErrors.no_of_students = true;
    if (!formData.teacher) newErrors.teacher = true;
    if (!formData.description) newErrors.description = true;
    // Image validation
    if (!formData.teacher_image) {
      newErrors.teacher_image = "Teacher image is required";
    } else if (
      typeof formData.teacher_image !== "string" &&
      formData.teacher_image.size > 10 * 1024 * 1024
    ) {
      newErrors.teacher_image = "Image must be less than 10MB";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Fetch teachers from API (unchanged)
  const fetchTeachers = async (query) => {
    if (!query) {
      setTeacherList([]);
      setShowDropdown(false);
      return;
    }
    setLoading(true);
    try {
      // console.log("thehergf",schoolId)
      const res = await axios.get(HttpService.teacher_list, {
        params: { search: query, limit: 10, school_id: schoolId },
      });
      setTeacherList(res.data.data.teachers);
      setShowDropdown(true);
    } catch (error) {
      console.error("Error fetching teachers:", error);
      setTeacherList([]);
    } finally {
      setLoading(false);
    }
  };

  // When typing: update input text, CLEAR any previous selection, and fetch options
  const handleTeacherInput = (e) => {
    const { value } = e.target;

    // store what the user typed purely as query/display text
    setFormData((prev) => ({ ...prev, teacher: value }));
    // since they typed, it's NOT a valid selection anymore
    setSelectedTeacherId(null);
    setFormData((prev) => ({ ...prev, teacher_image: "" }));

    fetchTeachers(value);
    setShowDropdown(!!value);
  };

  // Only this path can set a valid teacher in the form
  const handleSelectTeacher = (teacher) => {
    const url = teacher.profile_img || "";
    const relativePath = url.split(".cloudfront.net/")[1] || url;

    setFormData((prev) => ({
      ...prev,
      teacher: teacher.name,
      teacher_image: relativePath,
    }));
    setSelectedTeacherId(teacher._id);
    setShowDropdown(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;
    setLoader(true);

    const form = new FormData();
    if (params.id) form.append("id", params.id);
    form.append("grade", formData.grade);
    form.append("name", formData.name);
    form.append("no_of_students", formData.no_of_students);
    form.append("teacher", formData.teacher);
    form.append("description", formData.description);
    form.append("teacher_image", formData.teacher_image);
    form.append("school_id", schoolId);
    Postdata(HttpService.stream_add, form).then((res) => {
      if (res.status === 200) {
        toast.success(res.message);
        if (role === "admin" || role === "subadmin" || role_type === "schoolsubadmin" || role_type === "subadmin") {
          if (mode === "view") {
            navigate(`admin-school/view/${schoolId}`, {
              state: { mainTab: "Education", currentTab: "Streams" },
            });
          } else {
            navigate("navigation-dashboard", {
              replace: true,
              state: { mainTab: "Education", currentTab: "Streams" },
            });
          }
        } else {
          navigate(`education`, {
            replace: true,
            state: { currentTab: "Streams" },
          });
        }
      }
      // dispatch(message(res.message));
      setLoader(false);
    });
    console.log("Submitted as FormData:", formData);
  };

  const fetchData = () => {
    setLoader(true);
    Postdata(HttpService.stream_show, {
      id: params.id,
      school_id: schoolId,
    }).then((res) => {
      if (res.status === 200) {
        setFormData({
          grade: res.data.grade,
          no_of_students: res.data.no_of_students,
          name: res.data.name,
          description: res.data.description,
          teacher: res.data.teacher,
          teacher_image: res.data.teacher_image,
        });
      }
      // else {
      //     dispatch(message(res.message));
      // }
      setIsTeacherValid(true);
    });
    setLoader(false);
  };

  useEffect(() => {
    if (location.state?.type === "edit") {
      fetchData();
    }
  }, []);

  if (!isAccessible) {
    return (
      <>
        <Error403Page />
      </>
    );
  }

  return (
    <>
      <Topbar
        title={location.state?.type == "edit" ? "Edit Stream" : "Add Stream"}
        aerrow={true}
      />

      <div className="p-6 bg-gray-100 min-h-screen">
        <form onSubmit={(e) => handleSubmit(e)}>
          {/* Inline Inputs */}
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
            {/* Performance Year */}
            <div>
              <label className="block mb-1 font-medium text-gray-700">
                Grade <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="grade"
                placeholder="Enter Grade"
                className="input-field"
                value={formData.grade}
                onChange={handleInputChange}
                maxLength={10}
              />
              {errors.grade && (
                <span className="text-red-500 text-sm">Grade Required</span>
              )}
            </div>

            <div>
              <label className="block mb-1 font-medium text-gray-700">
                Stream Name<span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="name"
                placeholder="Enter Stream Name"
                className="input-field"
                value={formData.name}
                onChange={handleInputChange}
                maxLength={20}
              />
              {errors.name && (
                <span className="text-red-500 text-sm">Name Required</span>
              )}
            </div>

            <div>
              <label className="block mb-1 font-medium text-gray-700">
                Average Number of Students
                <span className="text-red-500">*</span>
              </label>
              <input
                type="number"
                name="no_of_students"
                placeholder="Enter Number of Students"
                className="input-field"
                value={formData.no_of_students}
                onChange={handleInputChange}
                max={100}
                min={1}
              />
              {errors.no_of_students && (
                <span className="text-red-500 text-sm">
                  Average Number of Students Required
                </span>
              )}
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
            <div className="relative w-full" ref={teacherBoxRef}>
              <label className="block mb-1 font-medium text-gray-700">
                Stream Class Teacher<span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="teacher"
                placeholder="Enter Stream Class Teacher"
                className="input-field w-full"
                value={formData.teacher}
                onChange={handleTeacherInput}
                onFocus={() => formData.teacher && setShowDropdown(true)}
                maxLength={30}
                role="combobox"
                aria-expanded={showDropdown}
                aria-autocomplete="list"
              />

              {errors.teacher && (
                <span className="text-red-500 text-sm">Teacher Required</span>
              )}

              {/* Dropdown */}
              {showDropdown && (
                <ul className="absolute z-10 w-full bg-white border border-gray-300 rounded mt-1 max-h-40 overflow-y-auto shadow-lg">
                  {loading && (
                    <li className=" py-3 text-gray-500">Loading...</li>
                  )}
                  {!loading && teacherList.length === 0 && (
                    <li className=" py-3 text-gray-500">No teachers found</li>
                  )}
                  {!loading &&
                    teacherList.map((teacher) => (
                      <li
                        key={teacher._id}
                        className="-ml-5 py-2 hover:bg-gray-100 cursor-pointer flex "
                        onClick={() => handleSelectTeacher(teacher)}
                      >
                        <img
                          src={teacher.profile_img}
                          alt="Photo"
                          className="w-8 h-auto mr-3"
                        ></img>
                        {teacher.name}
                      </li>
                    ))}
                </ul>
              )}
            </div>
          </div>

          <div>
            <label className="block mb-1 font-medium text-gray-700">
              Description<span className="text-red-500">*</span>
            </label>
            <textarea
              name="description"
              placeholder="Write Here"
              className="input-field"
              value={formData.description}
              onChange={handleInputChange}
            />
            {errors.description && (
              <span className="text-red-500 text-sm">Description Required</span>
            )}
          </div>

          <div className="w-full flex justify-center gap-3 mb-2 mt-4">
            <button
              type="submit"
              className="button-field-primary"
              style={{ width: "30%" }}
              disabled={loader}
            >
              {loader
                ? "Please wait..."
                : location.state?.type == "edit"
                  ? "Save"
                  : "Submit"}
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default Add_stream;
